import {
    CollateralsDTO,
    PostCollateralsAssetsDTO,
} from 'api/application/types.d'
import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function postApplicationCollateralsAssets<
    E extends CollateralsDTO,
>(uuid: string, collaterals: PostCollateralsAssetsDTO<E>) {
    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/api/v3/applications/${uuid}/collaterals-assets/`,
            collaterals,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to post application collateral assets: ${axiosError.message}`,
            axiosError,
            {
                applicationUuid: uuid,
            },
        )

        throw error
    }
}
